// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__11BbJ","logo":"footer_logo__ZHIC4","container":"footer_container__Yn8Zy"};